export default "__VITE_ASSET__CZah3M43__"